module.exports = __webpack_public_path__ + "img/Rectangle 18.278eb5ea.png";